import React from "react";
import Footer from "../components/Footer";

const sectionStyle = {
  marginBottom: "28px",
};

const h1Style = {
  fontSize: "2.2rem",
  fontWeight: 700,
  marginBottom: "12px",
  color: "#111111",
};

const h2Style = {
  fontSize: "1.2rem",
  fontWeight: 700,
  marginBottom: "10px",
  color: "#111111",
};

const pStyle = {
  fontSize: "1rem",
  lineHeight: 1.75,
  color: "#333333",
  marginBottom: "10px",
};

const liStyle = {
  fontSize: "1rem",
  lineHeight: 1.75,
  color: "#333333",
  marginBottom: "8px",
};

const cardStyle = {
  background: "#fff7fb",
  border: "1px solid #ffd3e6",
  borderRadius: "18px",
  padding: "20px",
  marginTop: "24px",
};

export default function DeleteAccount() {
  return (
    <div
      style={{
        background: "#ffffff",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          padding: "48px 20px 80px",
        }}
      >
        <div style={{ marginBottom: "32px" }}>
          <h1 style={h1Style}>Wayroot Account Deletion</h1>
          <p style={pStyle}>
            <strong>Wayroot Technologies Private Limited</strong>
          </p>
          <p style={pStyle}>
            This page explains how users can request deletion of their Wayroot
            account and associated personal data.
          </p>
        </div>

        <section style={sectionStyle}>
          <h2 style={h2Style}>How to request account deletion</h2>
          <p style={pStyle}>
            To request deletion of your Wayroot account, please email us from
            your registered email address.
          </p>

          <div style={cardStyle}>
            <p style={{ ...pStyle, marginBottom: 6 }}>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@wayroot.com?subject=Wayroot%20Account%20Deletion%20Request">
                support@wayroot.com
              </a>
            </p>
            <p style={{ ...pStyle, marginBottom: 0 }}>
              <strong>Subject line:</strong> Wayroot Account Deletion Request
            </p>
          </div>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Please include</h2>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>Your registered mobile number and/or email address</li>
            <li style={liStyle}>Your full name</li>
            <li style={liStyle}>Whether you are using Wayroot as a user, vehicle owner, or driver</li>
            <li style={liStyle}>A clear statement that you want your account deleted</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>What we delete</h2>
          <p style={pStyle}>
            Once your request is verified and approved, we will delete or
            anonymize your Wayroot account and associated personal information,
            subject to any legal, fraud-prevention, security, audit, payment,
            or regulatory retention requirements.
          </p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>Profile and account information</li>
            <li style={liStyle}>Contact details such as phone number and email address</li>
            <li style={liStyle}>Uploaded documents and files, where deletion is permitted</li>
            <li style={liStyle}>Vehicle, driver, or onboarding information linked to your account, where deletion is permitted</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>What we may retain</h2>
          <p style={pStyle}>
            We may retain limited information where required for legitimate
            business or legal reasons, including fraud prevention, dispute
            handling, tax, accounting, audit, platform security, and regulatory
            compliance.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Deletion timeline</h2>
          <p style={pStyle}>
            We aim to review and process valid account deletion requests within
            a reasonable time after identity verification.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Questions</h2>
          <p style={pStyle}>
            For any questions related to privacy or account deletion, contact us
            at{" "}
            <a href="mailto:support@wayroot.com">
              support@wayroot.com
            </a>.
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}